
















































































import { ICredentials } from "@/store/modules/auth/types";
import { Component, Vue } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import routerSwitch from "@/services/RouteSwitch";
import { ThemeConfig } from "@/plugins/config";

const namespace: string = "authModule";

@Component({
  name: "login",
})
export default class Login extends Vue {
  @Getter("theme")
  public theme!: ThemeConfig;

  @State("isLogged", { namespace })
  public isLogged!: boolean;

  @Action("login", { namespace })
  private login!: (user: Partial<ICredentials>) => Promise<void>;

  @Action("complete", { namespace })
  private complete!: () => Promise<void>;

  @Action("permissions", { namespace })
  private permissions!: () => Promise<void>;

  private isLoading = false;
  private httpReturnedObj: object = {};
  private credentials: Partial<ICredentials> = {};

  public async signIn(): Promise<void> {
    // Progress bar
    this.$Progress.start();
    try {
      this.isLoading = true;
      await this.login(this.credentials);
      await this.permissions();
      this.$router.replace(routerSwitch.getRoute());
      this.$Progress.finish();
    } catch (e) {
      this.httpReturnedObj = e;
      this.isLoading = false;
      this.$Progress.fail();
    } finally {
      this.isLoading = false;
    }
  }

  get httpReturn() {
    return this.httpReturnedObj;
  }

  get loadingStatus() {
    return this.isLoading;
  }

  public async beforeDestroy() {
    await this.complete();
  }
}
